import React from 'react';
import TextInput from '../../../components/forms/TextInput';
import UniversityWithOtherInput from '../../../components/forms/UniversityWithOtherInput';
import DepartmentSelectInput from '../../../components/forms/DepartmentSelectInput';
import FacultySelectInput from '../../../components/forms/FacultySelectInput';

function StudentSignupForm({ register, errors, watch }) {
  return (
    <div className=''>

      <UniversityWithOtherInput
        register={register}
        errors={errors}
        watch={watch}
        name="university"
        otherInputName="other_university"
      />

      <FacultySelectInput
        name="faculty"
        register={register}
        errors={errors}
        className='mb-4'
      />

      <DepartmentSelectInput 
        register={register}
        errors={errors}
        name="department"
        validationRules={{ required: 'University is required' }}
        withOtherOption={true}
        facultyId={watch('faculty') || null}
      />

      {watch('department') === 'other' && (
        <TextInput
          label="Department Name"
          name="other_department"
          register={register}
          errors={errors}
          validationRules={{ required: 'Department name is required' }}
        />
      )}
      
      <TextInput
        label="Matriculation Number"
        name="mat_no"
        type="text"
        placeholder="12345678"
        register={register}
        errors={errors}
        validationRules={{ required: 'Matriculation number is required' }}
      />
    </div>
  );
}

export default StudentSignupForm;
